import { useState, useCallback } from 'react'
import { api } from '../utils/apiComponent/apiClient'
import { endpoints } from '../utils/endpoints'

export function usePromoCodes() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // Valider un code promo (public)
  const validatePromoCode = useCallback(async (code, courseId, cartAmount = null) => {
    setLoading(true)
    setError(null)
    
    try {
      const params = new URLSearchParams({
        code,
        courseId
      })
      
      if (cartAmount !== null) {
        params.append('cartAmount', cartAmount.toString())
      }
      
      const response = await api.get(
        `${endpoints.validatePromoCode}?${params.toString()}`,
        { isPublicRoute: true }
      )
      
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de la validation du code promo"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  // Créer un code promo (admin)
  const createPromoCode = useCallback(async (promoCodeData) => {
    setLoading(true)
    setError(null)
    
    try {
      const response = await api.post(endpoints.createPromoCode, promoCodeData)
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de la création du code promo"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  // Lister les codes promo (admin)
  const getPromoCodes = useCallback(async (filters = {}) => {
    setLoading(true)
    setError(null)
    
    try {
      const params = new URLSearchParams()
      
      if (filters.page) params.append('page', filters.page.toString())
      if (filters.limit) params.append('limit', filters.limit.toString())
      if (filters.isActive !== undefined) params.append('isActive', filters.isActive.toString())
      if (filters.search) params.append('search', filters.search)
      
      const queryString = params.toString()
      const url = queryString ? `${endpoints.promoCodes}?${queryString}` : endpoints.promoCodes
      
      const response = await api.get(url)
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de la récupération des codes promo"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  // Récupérer un code promo par ID (admin)
  const getPromoCode = useCallback(async (promoCodeId) => {
    setLoading(true)
    setError(null)
    
    try {
      const response = await api.get(endpoints.getPromoCode(promoCodeId))
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de la récupération du code promo"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  // Modifier un code promo (admin)
  const updatePromoCode = useCallback(async (promoCodeId, updateData) => {
    setLoading(true)
    setError(null)
    
    try {
      const response = await api.patch(endpoints.updatePromoCode(promoCodeId), updateData)
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de la mise à jour du code promo"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  // Supprimer un code promo (admin)
  const deletePromoCode = useCallback(async (promoCodeId) => {
    setLoading(true)
    setError(null)
    
    try {
      const response = await api.delete(endpoints.deletePromoCode(promoCodeId))
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de la suppression du code promo"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    error,
    validatePromoCode,
    createPromoCode,
    getPromoCodes,
    getPromoCode,
    updatePromoCode,
    deletePromoCode
  }
}

